import type { FaireProductEntity } from "../../entity_types/product";

export const p_ao08l9x2: FaireProductEntity = {
  token: "p_ao08l9x2",
  type: "product",
  name: "Grad Book Stack Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/905416fa2ba0d03eccaff32d5a1718395d8972c51e47e58ff6c536111c6104c8/1528388401.png",
  galleryImageUrls: [
    "https://cdn.faire.com/res/hszgttpjt/image/upload/05c9d1a3f734df663748b264c6df24f75adcf4dc65c50c70947741b6c9312a13/1528388401.png",
    "https://cdn.faire.com/fastly/cfe8da7f6c99ec8fe920566042dd04ee2c766c481973b1d425da5a4a4b2e744b.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:48.863Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
